import { render } from "./PlayHallView.vue?vue&type=template&id=19b2f684&scoped=true"
import script from "./PlayHallView.vue?vue&type=script&lang=js"
export * from "./PlayHallView.vue?vue&type=script&lang=js"

import "./PlayHallView.vue?vue&type=style&index=0&id=19b2f684&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b2f684"]])

export default __exports__